import React, { createContext, useContext, useEffect, useState } from "react";
import { authApi } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("alias_hq_token");
    const cached = localStorage.getItem("alias_hq_user");
    if (token && cached) {
      setUser(JSON.parse(cached));
      authApi.me().then((r) => setUser(r.data)).catch(() => {}).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const r = await authApi.login(email, password);
    localStorage.setItem("alias_hq_token", r.data.access_token);
    localStorage.setItem("alias_hq_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("alias_hq_token");
    localStorage.removeItem("alias_hq_user");
    setUser(null);
    window.location.href = "/login";
  };

  // Re-fetch the current user (e.g. after AccountPage edits the display name /
  // preferred alias) so the sidebar badge and every prompt-context surface
  // picks up the new identity without a full reload.
  const refreshUser = async () => {
    try {
      const r = await authApi.me();
      const merged = { ...(user || {}), ...r.data };
      localStorage.setItem("alias_hq_user", JSON.stringify(merged));
      setUser(merged);
      return merged;
    } catch {
      return user;
    }
  };

  return <AuthCtx.Provider value={{ user, loading, login, logout, refreshUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
